export default "__VITE_ASSET__207hc6n___"